// ANIMATIONS

document.addEventListener(
  "DOMContentLoaded",
  () => {
    gsap.config({
      nullTargetWarn: false,
    });

    gsap.registerPlugin(ScrollTrigger);
    const deviceHeight = window.innerHeight;
    const isDesktop = window.matchMedia("(min-width: 768px)").matches;

    /* TIMELINES */

    const timelines = document.querySelectorAll("[timeline]");
    if (timelines) {
      /* Function to add style */
      function addStyle(styles) {
        /* Create style element */
        var css = document.createElement("style");
        css.type = "text/css";

        if (css.styleSheet) css.styleSheet.cssText = styles;
        else css.appendChild(document.createTextNode(styles));

        /* Append style to the head element */
        document.getElementsByTagName("head")[0].appendChild(css);
      }

      addStyle(".pin-spacer { max-width: 100% !important; }");

      timelines.forEach((timelineSection) => {
        let pin = timelineSection.getAttribute("data-pin") == "true" ? timelineSection : false;
        let scrub = timelineSection.getAttribute("data-scrub") ? timelineSection.getAttribute("data-scrub") : 1;
        let start = timelineSection.getAttribute("data-start") ? timelineSection.getAttribute("data-start") : "top top";
        let end = timelineSection.getAttribute("data-end") ? timelineSection.getAttribute("data-end") : "+=4000";
        let toggleActions = timelineSection.getAttribute("data-toggle-actions") ? timelineSection.getAttribute("data-toggle-actions") : "play pause play reset";
        let mobileTimeline = timelineSection.getAttribute("data-timeline-mobile") ? true : false;

        let animationElements = timelineSection.querySelectorAll("[data-animation]");

        if (isDesktop || mobileTimeline === true) {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: timelineSection,
              pin: pin,
              scrub: scrub,
              start: start,
              end: end,
              toggleActions: toggleActions,
            },
          });

          animationElements.forEach((element) => {
            let animationType = element.dataset.animationType;
            let delay = element.dataset.delay;

            if (animationType == "fromTo") {
              tl.fromTo(element, fromAnimation(element), toAnimation(element), delay);
            } else if (animationType == "to") {
              tl.to(element, toAnimation(element), delay);
            } else {
              tl.from(element, fromAnimation(element), delay);
            }
          });
        }
      });
    }

    /* Add class on scroll */
    const classOnScrollElements = gsap.utils.toArray("[data-add-class-on-scroll]");
    if (classOnScrollElements) {
      classOnScrollElements.forEach((element, index) => {
        let activeClass = element.getAttribute("data-add-class-on-scroll");

        ScrollTrigger.batch(element, {
          toggleClass: activeClass,
          once: true,
        });
      });
    }

    /* ANIMATIONS */
    function fromAnimation(element) {
      let ease = (element.dataset.ease || "power3") + "." + (element.dataset.easeDirection || "out");

      return {
        ...(element.dataset.fromXType == "px" && {
          ...(element.dataset.fromX && {
            x: element.dataset.fromX,
          }),
        }),
        ...(element.dataset.fromXType == "%" && {
          ...(element.dataset.fromX && {
            xPercent: element.dataset.fromX,
          }),
        }),
        ...(element.dataset.fromYType == "px" && {
          ...(element.dataset.fromY && {
            y: element.dataset.fromY,
          }),
        }),
        ...(element.dataset.fromYType == "%" && {
          ...(element.dataset.fromY && {
            yPercent: element.dataset.fromY,
          }),
        }),
        ...(element.dataset.fromScale && {
          scale: element.dataset.fromScale,
        }),
        ...(element.dataset.fromScaleX && {
          scaleX: element.dataset.fromScaleX,
        }),
        ...(element.dataset.fromScaleY && {
          scaleY: element.dataset.fromScaleY,
        }),
        ...(element.dataset.fromRotation && {
          rotation: element.dataset.fromRotation,
        }),
        ...(element.dataset.fromRotation && {
          rotation: element.dataset.fromRotation,
        }),
        ...(element.dataset.fromOpacity && {
          opacity: element.dataset.fromOpacity,
        }),
        ...(element.dataset.animationType == "from" && {
          duration: element.dataset.duration ? Number(element.dataset.duration) : 0.6,
          delay: element.dataset.delay ? Number(element.dataset.delay) : 0,
          ease: ease,
          stagger: {
            each: 0.1,
          },
        }),
      };
    }

    function toAnimation(element) {
      let ease = (element.dataset.ease || "power3") + "." + (element.dataset.easeDirection || "out");

      return {
        ...(element.dataset.toXType == "px" && {
          ...(element.dataset.toX && {
            x: element.dataset.toX,
          }),
        }),
        ...(element.dataset.toXType == "%" && {
          ...(element.dataset.toX && {
            xPercent: element.dataset.toX,
          }),
        }),
        ...(element.dataset.toYType == "px" && {
          ...(element.dataset.toY && {
            y: element.dataset.toY,
          }),
        }),
        ...(element.dataset.toYType == "%" && {
          ...(element.dataset.toY && {
            yPercent: element.dataset.toY,
          }),
        }),
        ...(element.dataset.toScale && {
          scale: element.dataset.toScale,
        }),
        ...(element.dataset.toRotation && {
          rotation: element.dataset.toRotation,
        }),
        ...(element.dataset.toRotation && {
          rotation: element.dataset.toRotation,
        }),
        ...(element.dataset.toOpacity && {
          opacity: Number(element.dataset.toOpacity),
        }),
        ...((element.dataset.animationType !== "to" || element.dataset.animationType !== "fromTo") && {
          duration: element.dataset.duration ? Number(element.dataset.duration) : 0.6,
          ease: ease,
          delay: element.dataset.delay ? Number(element.dataset.delay) : 0,
          stagger: {
            each: 0.1,
          },
        }),
      };
    }

    let animate = (selectors, from, to) => {
      let animateElements = document.querySelectorAll(selectors);

      if (animateElements) {
        let selectorsArray = selectors.split(",");
        if (selectors.includes("custom")) {
          animateElements.forEach((element) => {
            const isTimeline = element.closest("[timeline]") !== null;
            if (!isTimeline) {
              const customTimeline = gsap.timeline({
                scrollTrigger: {
                  trigger: element,
                  start: "top bottom",
                  end: "bottom top",
                  toggleActions: "restart none none reset",
                },
              });
              if (element.dataset.animationType == "fromTo") {
                customTimeline.fromTo(element, fromAnimation(element), toAnimation(element));
              }
              if (element.dataset.animationType == "from") {
                customTimeline.from(element, fromAnimation(element));
              }
              if (element.dataset.animationType == "to") {
                customTimeline.to(element, toAnimation(element));
              }
            }
          });
        } else {
          gsap.defaults();
          gsap.set(selectorsArray, from);

          ScrollTrigger.batch(selectorsArray, {
            interval: 0.3, // time window (in seconds) for batching to occur.
            onEnter: (batch) => gsap.to(batch, to),
            //onLeaveBack: (batch) => gsap.set(batch, from),
          });

          ScrollTrigger.addEventListener("refreshInit", () => gsap.set(selectorsArray, { y: 0 }));
        }
      }
    };

    animate(
      '[data-animation="fadeup"]',
      {
        y: 40,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        duration: function (index, target) {
          return target.dataset.duration ? Number(target.dataset.duration) : 0.6;
        },
        ease: Expo.out,
        delay: function (index, target) {
          return target.dataset.delay ? Number(target.dataset.delay) : 0;
        },
        stagger: {
          each: 0.1,
        },
        overwrite: true,
      }
    );

    animate(
      '[data-animation="fadein"]',
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        duration: function (index, target) {
          return target.dataset.duration ? Number(target.dataset.duration) : 1;
        },
        ease: Expo.out,
        delay: function (index, target) {
          return target.dataset.delay ? Number(target.dataset.delay) : 0;
        },
        stagger: {
          each: 0.1,
        },
        overwrite: true,
      }
    );

    animate(
      '[data-animation="zoomin"]',
      { scale: 1.1, autoAlpha: 0 },
      {
        scale: 1,
        autoAlpha: 1,
        duration: function (index, target) {
          return target.dataset.duration ? Number(target.dataset.duration) : 1;
        },
        delay: function (index, target) {
          return target.dataset.delay ? Number(target.dataset.delay) : 0;
        },
        stagger: {
          each: 0.1,
        },
        overwrite: true,
      }
    );

    animate('[data-animation="custom"]');

    let revealContainers = document.querySelectorAll('[data-animation="imagereveal"]');

    revealContainers.forEach((container) => {
      let image = container.querySelector("img");
      let yDirection = function () {
        return container.dataset.animationDirection == "down" ? "-100" : container.dataset.animationDirection == "left" ? "0" : container.dataset.animationDirection == "right" ? "0" : "100";
      };
      let xDirection = function () {
        return container.dataset.animationDirection == "left" ? "100" : container.dataset.animationDirection == "right" ? "-100" : 0;
      };
      let duration = function () {
        return container.dataset.duration ? Number(container.dataset.duration) : 1;
      };
      let delay = function () {
        return container.dataset.delay ? Number(container.dataset.delay) : 0.2;
      };

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          toggleActions: "restart none none reset",
        },
      });

      tl.set(container, {
        autoAlpha: 0,
        delay: delay(),
        yPercent: 0,
        xPercent: 0,
      });
      tl.to(container, 0, {
        autoAlpha: 1,
        yPercent: yDirection(),
        xPercent: xDirection(),
      });
      tl.to(container, duration(), {
        yPercent: 0,
        xPercent: 0,
        ease: Expo.out,
      });
      tl.from(image, duration(), {
        yPercent: -yDirection(),
        xPercent: -xDirection(),
        scale: 1.3,
        delay: -duration(),
        ease: Expo.out,
      });
    });

    //PARALLAX

    gsap.utils.toArray("[parallax]").forEach((element) => {
      const topDistance = element.getBoundingClientRect().top;

      //const bottomDistance = element.getBoundingClientRect().bottom + element.offsetHeight ;
      let distanceToTop = window.pageYOffset + topDistance;
      const bgParallax = element.hasAttribute("parallax-background");
      const depth = bgParallax ? -0.3 : element.dataset.depth ? element.dataset.depth : 0.3;
      const direction = element.dataset.direction;
      const mobileParallax = element.dataset.mobileParallax ? element.dataset.mobileParallax : true;
      const movement = -((element.offsetHeight / 2) * depth);
      const from = distanceToTop < deviceHeight ? 0 : -movement;
      const parallaxElement = bgParallax ? element.querySelector(".wp-block-cover__image-background") : element;

      if (isDesktop || mobileParallax === true) {
        const parallaxTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: parallaxElement,
            start: function () {
              return topDistance <= deviceHeight ? "top " + topDistance : "top bottom";
            },
            end: "bottom top",
            scrub: true,
          },
        });
        if (direction == "horizontal") {
          parallaxTimeline.fromTo(
            parallaxElement,
            {
              x: topDistance <= deviceHeight ? 0 : -depth * 100,
            },
            {
              x: depth * 100,
              ease: "none",
            }
          );
        } else {
          parallaxTimeline.fromTo(
            parallaxElement,
            {
              ...(bgParallax && { scale: 1.05 }),
              y: from,
              ease: "none",
            },
            {
              ...(bgParallax && { scale: 1.05 }),
              y: movement,
              ease: "none",
            }
          );
        }
      }
    });

    // REVEAL TEXT

    var splitWords = function (element) {
      element.dataset.splitText = element.textContent.trim();
      element.innerHTML = element.textContent
        .split(/\s/)
        .map(function (word) {
          return word
            .split("-")
            .map(function (word) {
              return '<span class="word">' + word + "</span>";
            })
            .join('<span class="hyphen">-</span>');
        })
        .join('<span class="whitespace"> </span>');
    };

    var splitLines = function (element) {
      //var elements = container.querySelectorAll(selector);

      splitWords(element);

      var lines = getLines(element);

      var wrappedLines = "";
      lines.forEach(function (wordsArr) {
        wrappedLines += '<span class="line"><span class="mask-up">';
        wordsArr.forEach(function (word) {
          wrappedLines += word.outerHTML;
        });
        wrappedLines += "</span></span>";
      });
      element.innerHTML = wrappedLines;
    };

    var getLines = function (el) {
      var lines = [];
      var line;
      var words = el.querySelectorAll("span");
      var lastTop;
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (word.offsetTop != lastTop) {
          // Don't start with whitespace
          if (!word.classList.contains("whitespace")) {
            lastTop = word.offsetTop;

            line = [];
            lines.push(line);
          }
        }
        line.push(word);
      }
      return lines;
    };

    if (document.querySelector('[data-animation="textreveal"]')) {
      gsap.utils.toArray('[data-animation="textreveal"]').forEach((element) => {
        let type = element.dataset.revealType;
        let rotationY = element.dataset.animationDirection == "up" || element.dataset.animationDirection == "down" ? 0 : element.dataset.animationDirection == "right" ? -90 : 90;
        let rotationX = element.dataset.animationDirection == "left" || element.dataset.animationDirection == "right" ? 0 : element.dataset.animationDirection == "up" ? -90 : 90;
        let y = element.dataset.animationDirection == "left" || element.dataset.animationDirection == "right" ? 0 : element.dataset.animationDirection == "up" ? 60 : -60;
        let x = element.dataset.animationDirection == "up" || element.dataset.animationDirection == "down" ? 0 : element.dataset.animationDirection == "right" ? -60 : 60;
        gsap.defaults();
        gsap.set(element, { autoAlpha: 1 });

        if (type == "letter") {
          //let element = revealText.querySelector("h1,h2,h3,h4,h5,h6");

          element.innerHTML = element.textContent.replace(/([-A-Za-z0-9!$#%^&*@()_+|~=’`{}[\]:";'<>?,./]+)/g, '<div class="word inline-flex">$1</div>');

          let words = element.querySelectorAll(".word");
          words.forEach((word) => {
            word.innerHTML = word.textContent.replace(/[-A-Za-z0-9!$#%^&*@()_+|~=’`{}[\]:";'<>?,./]/g, "<div class='perspective'><div class='letter'><div>$&</div></div></div>");
          });

          const letters = element.querySelectorAll(".letter");

          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: element,
              toggleActions: "restart none none reset",
            },
          });

          tl.fromTo(
            letters,
            1.6,
            {
              transformOrigin: "center",
              rotationY: rotationY,
              rotationX: rotationX,
              x: x,
              y: y,
            },
            {
              rotationY: 0.1,
              rotationX: 0.1,
              x: 0,
              y: 0,
              stagger: 0.025,
              ease: "power3".out,
            }
          );
        } else {
          splitLines(element);
          let lines = element.querySelectorAll(".mask-up");
          gsap.set(lines, { yPercent: 100 });
          ScrollTrigger.batch(lines, {
            interval: 0.16,
            onEnter: (batch) =>
              gsap.to(batch, {
                yPercent: 0,
                duration: function (index, target) {
                  return element.dataset.duration ? Number(target.closest('[data-animation="textreveal"]').dataset.duration) : 0.5;
                },
                delay: function (index, target) {
                  return element.dataset.delay ? Number(target.closest('[data-animation="textreveal"]').dataset.delay) : 0.1;
                },
                ease: "power3".out,
                stagger: { each: 0.1 },
                overwrite: true,
              }),
            //onLeaveBack: (batch) =>
            //gsap.set(batch, { yPercent: 100, overwrite: true }),
          });
        }
      });

      ScrollTrigger.addEventListener("refreshInit", () => gsap.set('[data-animation="textreveal"]', { y: 0 }));
    }
  },
  true
);
